export enum FormDetailComponentState {
    NotFound,
    Loading,
    Found,
    Forbidden,
    Error
}
